@if (showHeaderRow()) {
<div class="header-row">
    <div class="total">
        @if (showTotalNumber()) {
            <p>Found {{ pagination().total }} items</p>
        }
        @if (showEmbeddedWarning()) {
            <p class="box box-warning" i18n>
                This report contains a large number of rows. Only the first {{pagination().size}} rows are stored in this event.
            </p>
        }
    </div>
    @if (showCsvDownload()) {
        <button mat-stroked-button color="primary" (click)="downloadCsv()" aria-haspopup="dialog">
        Download this table as CSV
        </button>
    }
</div>
}
<div class="table-container">
    <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)">

        @for (column of displayedColumns(); track column.id) {
            <ng-container matColumnDef="{{column.id}}">
                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{column.label}}"> {{column.label}} </th>
                <td mat-cell *matCellDef="let element">
                    @if (column.type === 'date') {
                        {{element[column.id] | date}}
                    } @else if (column.type === 'datetime') {
                        {{element[column.id] | date:'medium'}}
                    } @else if (column.type === 'numeric') {
                        {{element[column.id] | round:precision()}}
                    } @else if (column.type === 'link') {
                        <a [routerLink]="getDocLink(column.doc_type, element[column.id])" aria-label="View {{column.doc_type}} {{element[column.id]}} details">{{column.label}}</a>
                    } @else if (column.type === 'preview') {
                        @if (hasDocViewHandler()) {
                            <button mat-button (click)="openDocPreview(column.doc_type, element[column.id]); $event.preventDefault()" aria-label="Preview {{column.doc_type}} {{element[column.id]}}">{{column.label}}</button>
                        } @else {
                            <a [routerLink]="getDocLink(column.doc_type, element[column.id])" aria-label="View {{column.doc_type}} {{element[column.id]}} details">{{column.label}}</a>
                        }
                    } @else {
                        {{element[column.id]}}
                    }
                </td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumnsId()"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsId()"></tr>
    </table>
</div>
@if (!noPagination()) {
  <mat-paginator
    risrPaginator
    [pageSize]="pagination().size"
    [length]="pagination().total"
    (page)="onPageChange($event)">
  </mat-paginator>
}
